export const MINIMUM_OF_CRITERIA_DISPLAYED = 3;

export enum SHOW_BUTTONS {
  SHOW_MORE = 1,
  SHOW_LESS = 2,
}
